module.exports = __webpack_public_path__ + "static/img/class_1.0b38768f.jpg";